import { EmployerHero } from "../components/employers/EmployerHero";

import { ATSComparison } from "../components/employers/ATSComparison";
import { AILayers } from "../components/employers/AILayers";
import { AudienceSection } from "../components/employers/AudienceSection";
import { EmployerCTA } from "../components/employers/EmployerCTA";

export default function EmployersPage() {
  return (
    <main className="qh-employer">

      <EmployerHero />

      

      <ATSComparison />

      <AILayers />

      <AudienceSection />

      <EmployerCTA />

      <EmployerStyles />

    </main>
  );
}

const EmployerStyles = () => (
  <style>{`

/* =========================================================
   EMPLOYER PAGE
   Matched to the supplied sample HTML
   ========================================================= */

.qh-employer {
  --qh-ink: #14150f;
  --qh-ink-soft: #3a3c35;
  --qh-paper: #f5f6f2;
  --qh-paper-dim: #ebece5;
  --qh-quantum: #1caa3c;
  --qh-quantum-deep: #0b5c22;
  --qh-steel: #6b6f68;
  --qh-line: rgba(20, 21, 15, 0.1);
  --qh-line-dark: rgba(245, 246, 242, 0.14);
  width: 100%;
  overflow-x: hidden;
  background: var(--qh-paper);
  color: var(--qh-ink);
  font-family: "Inter", sans-serif;
  line-height: normal;
  -webkit-font-smoothing: antialiased;
}

.qh-employer * {
  box-sizing: border-box;
}

.qh-employer h1,
.qh-employer h2,
.qh-employer h3 {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.qh-employer a {
  color: inherit;
  text-decoration: none;
}


/* =========================================================
   EMPLOYER HERO
   ========================================================= */

.qh-employer-hero {
  position: relative;
  background: #f5f6f2;
  color: #14150f;
  overflow: hidden;

  padding: 120px 32px 100px;

  border-bottom: 1px solid #d8ddd3;
}


/* Animated AI network canvas */

.qh-hero-canvas {
  position: absolute;

  inset: 0;

  width: 100%;
  height: 100%;

  pointer-events: none;

  opacity: 0.9;
}


/* Hero content */

.qh-hero-inner {
  position: relative;

  z-index: 2;

  max-width: 1180px;

  margin: 0 auto;

  text-align: left;
}


/* =========================================================
   EYEBROW
   ========================================================= */

.qh-hero-eyebrow {
  display: inline-flex;

  align-items: center;

  gap: 10px;

  margin-bottom: 28px;

  padding: 7px 12px;

  border: 1px solid #d8ddd3;

  border-radius: 2px;

  background: rgba(255, 255, 255, 0.7);

  font-family: "JetBrains Mono", monospace;

  font-size: 11.5px;

  line-height: 1.3;

  letter-spacing: 0.04em;

  text-transform: uppercase;

  color: #176d2e;
}


/* Green live indicator */

.qh-hero-dot {
  width: 7px;
  height: 7px;

  flex-shrink: 0;

  border-radius: 50%;

  background: #1caa3c;
}


/* =========================================================
   HERO HEADING
   ========================================================= */

.qh-hero-inner h1 {
  max-width: 900px;

  margin: 0 0 26px;

  font-size: clamp(36px, 5.4vw, 68px);

  line-height: 1.04;

  letter-spacing: -0.035em;

  font-weight: 600;
}


.qh-hero-inner h1 em {
  font-style: normal;

  color: #176d2e;
}


/* =========================================================
   HERO DESCRIPTION
   ========================================================= */

.qh-hero-lede {
  max-width: 520px;

  margin: 0 0 40px;

  color: #555d54;

  font-size: 18px;

  line-height: 1.6;
}


/* =========================================================
   HERO CTA
   ========================================================= */

.qh-hero-cta-row {
  display: flex;

  align-items: center;

  gap: 22px;

  flex-wrap: wrap;

  margin-bottom: 76px;
}


/* Primary */

.qh-hero-primary {
  display: inline-flex;

  align-items: center;

  justify-content: center;

  background: #1caa3c;

  color: #f5f6f2;

  border: none;

  border-radius: 2px;

  padding: 15px 26px;

  font-size: 15px;

  font-weight: 600;

  line-height: 1;

  text-decoration: none;

  cursor: pointer;

  transition:
    transform 0.15s ease,
    background 0.15s ease;
}


.qh-hero-primary:hover {
  background: #176d2e;

  transform: translateY(-1px);
}


/* Ghost */

.qh-hero-ghost {
  font-family: "JetBrains Mono", monospace;

  font-size: 13px;

  line-height: 1.4;

  color: #14150f;

  text-decoration: none;

  border-bottom: 1px solid #d8ddd3;

  padding-bottom: 3px;

  transition:
    color 0.15s ease,
    border-color 0.15s ease;
}


.qh-hero-ghost:hover {
  color: #176d2e;

  border-color: #176d2e;
}


/* =========================================================
   HERO STATS
   ========================================================= */

.qh-stat-strip {
  display: grid;

  grid-template-columns: repeat(4, 1fr);

  border-top: 1px solid #d8ddd3;

  padding-top: 32px;
}


.qh-stat {
  min-width: 0;
}


.qh-stat + .qh-stat {
  border-left: 1px solid #d8ddd3;

  padding-left: 28px;
}


/* Number */

.qh-stat-number {
  font-family: "Poppins", sans-serif;

  font-size: 30px;

  line-height: 1;

  font-weight: 600;

  letter-spacing: -0.03em;

  color: #14150f;
}


.qh-stat-number span {
  color: #176d2e;
}


/* Label */

.qh-stat-label {
  margin-top: 6px;

  font-family: "JetBrains Mono", monospace;

  font-size: 11px;

  line-height: 1.4;

  letter-spacing: 0.03em;

  text-transform: uppercase;

  color: #7b8077;
}


/* =========================================================
   SHARED SECTION STYLES
   ========================================================= */

.qh-wrap {
  max-width: 1180px;

  margin: 0 auto;
}


.qh-section-head {
  max-width: 640px;

  margin-bottom: 56px;
}


.qh-tag {
  display: block;

  margin-bottom: 16px;

  font-family: "JetBrains Mono", monospace;

  font-size: 11.5px;

  line-height: 1.4;

  letter-spacing: 0.04em;

  text-transform: uppercase;

  color: #176d2e;
}


.qh-section-head h2 {
  margin: 0;

  font-size: clamp(28px, 3.4vw, 42px);

  line-height: 1.12;

  letter-spacing: -0.025em;

  font-weight: 600;

  color: #14150f;
}


.qh-section-head p {
  margin-top: 18px;

  margin-bottom: 0;

  font-size: 16px;

  line-height: 1.6;

  color: #7b8077;
}


/* =========================================================
   ATS COMPARISON
   ========================================================= */

.qh-not-ats {
  background: #f5f6f2;

  padding: 100px 32px;
}


.qh-compare {
  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 0;

  border: 1px solid #d8ddd3;

  border-radius: 4px;

  overflow: hidden;
}


.qh-compare-col {
  padding: 40px;
}


.qh-compare-col.old {
  background: #eef0ea;
}


.qh-compare-col.new {
  background: #14150f;

  color: #f5f6f2;
}


.qh-compare-col + .qh-compare-col {
  border-left: 1px solid #d8ddd3;
}


.qh-compare-label {
  display: block;

  margin-bottom: 22px;

  font-family: "JetBrains Mono", monospace;

  font-size: 11px;

  line-height: 1.4;

  letter-spacing: 0.04em;

  text-transform: uppercase;

  opacity: 0.6;
}


.qh-compare-col ul {
  list-style: none;

  padding: 0;

  margin: 0;
}


.qh-compare-col li {
  display: flex;

  align-items: flex-start;

  gap: 12px;

  padding: 12px 0;

  border-top: 1px solid #d8ddd3;

  font-size: 15px;

  line-height: 1.5;
}


.qh-compare-col.new li {
  border-top-color: rgba(245, 246, 242, 0.14);
}


.qh-compare-col li:first-child {
  border-top: none;
}


.qh-compare-col .mk {
  flex-shrink: 0;

  padding-top: 2px;

  width: 25px;

  font-family: "JetBrains Mono", monospace;

  font-size: 12px;

  color: #7b8077;
}


.qh-compare-col.new .mk {
  color: #1caa3c;
}


/* =========================================================
   AI LAYERS
   ========================================================= */

.qh-layers {
  background: #eef0ea;

  padding: 100px 32px;
}


.qh-layer-list {
  border-top: 1px solid #d8ddd3;
}


.qh-layer {
  display: grid;

  grid-template-columns: 120px 1fr 1.3fr;

  gap: 28px;

  align-items: flex-start;

  padding: 34px 0;

  border-bottom: 1px solid #d8ddd3;
}


.qh-layer-index {
  font-family: "JetBrains Mono", monospace;

  font-size: 13px;

  line-height: 1.5;

  color: #176d2e;
}


.qh-layer h3 {
  margin: 0 0 8px;

  font-size: 20px;

  line-height: 1.25;

  font-weight: 600;

  color: #14150f;
}


.qh-layer p {
  margin: 0;

  font-size: 15px;

  line-height: 1.6;

  color: #7b8077;
}


/* =========================================================
   AUDIENCE
   ========================================================= */

.qh-audience {
  background: #f5f6f2;

  padding: 100px 32px;
}


.qh-aud-grid {
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 1px;

  background: #d8ddd3;
}


.qh-aud-card {
  background: #f5f6f2;

  padding: 36px 32px;
}


.qh-mono {
  display: block;

  margin-bottom: 16px;

  font-family: "JetBrains Mono", monospace;

  font-size: 11.5px;

  line-height: 1.4;

  letter-spacing: 0.04em;

  text-transform: uppercase;

  color: #176d2e;
}


.qh-aud-card h3 {
  margin: 0 0 12px;

  font-size: 19px;

  line-height: 1.3;

  font-weight: 600;

  color: #14150f;
}


.qh-aud-card p {
  margin: 0;

  font-size: 14.5px;

  line-height: 1.6;

  color: #7b8077;
}

/* =========================================================
   EMPLOYER - STARTUP TRACK
   ========================================================= */

.qh-employer .hiring-tracks-preview {
  padding: 76px 0;
  background: linear-gradient(
    180deg,
    var(--qh-paper-dim) 0%,
    var(--qh-paper) 100%
  );
  border-top: 1px solid var(--qh-line);
  border-bottom: 1px solid var(--qh-line);
}


/* =========================================================
   SECTION HEADER
   ========================================================= */

.qh-employer .hiring-tracks-preview .wrap {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 32px;
}

.qh-employer .hiring-tracks-preview .section-head {
  max-width: 640px;
  margin-bottom: 56px;
}

.qh-employer .hiring-tracks-preview .tag {
  display: block;

  font-family: "JetBrains Mono", monospace;
  font-size: 11.5px;
  text-transform: uppercase;

  color: var(--qh-quantum-deep);

  letter-spacing: 0.04em;

  margin-bottom: 16px;
}

.qh-employer .hiring-tracks-preview .section-head h2 {
  font-family: "Poppins", sans-serif;

  font-size: clamp(28px, 3.4vw, 42px);
  line-height: 1.12;

  margin: 0;
}

.qh-employer .hiring-tracks-preview .section-head p {
  font-size: 16px;
  color: var(--qh-steel);

  margin-top: 18px;

  line-height: 1.6;
}


/* =========================================================
   SPOTLIGHT WRAPPER
   ========================================================= */

.qh-employer .htp-spotlight-wrap {
  max-width: 1180px;

  margin: 0 auto;

  padding: 0 32px;
}


/* =========================================================
   STARTUP SPOTLIGHT CARD
   ========================================================= */

.qh-employer .htp-spotlight {
  --htp-accent: #1caa3c;
  --htp-accent-deep: #0b5c22;
  --htp-accent-tint: #e7f5ea;

  display: block;

  position: relative;

  background: var(--qh-paper);

  border: 1px solid var(--qh-line);

  border-radius: 14px;

  border-top: 4px solid var(--htp-accent);

  padding: 36px 40px;

  overflow: hidden;

  color: var(--qh-ink);

  text-decoration: none;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.qh-employer .htp-spotlight:hover {
  transform: translateY(-4px);

  box-shadow:
    0 18px 36px rgba(20, 21, 15, 0.09);
}


/* =========================================================
   DECORATIVE BACKGROUND
   ========================================================= */

.qh-employer .htp-bg {
  position: absolute;

  right: -30px;
  bottom: -30px;

  width: 190px;
  height: 190px;

  opacity: 0.05;

  pointer-events: none;

  z-index: 0;
}

.qh-employer .htp-bg svg {
  width: 100%;
  height: 100%;

  stroke: var(--htp-accent);

  fill: none;
}


/* =========================================================
   INNER CONTENT
   ========================================================= */

.qh-employer .htp-spotlight-inner {
  position: relative;

  z-index: 1;

  display: flex;

  align-items: center;

  gap: 28px;

  flex-wrap: wrap;
}


/* =========================================================
   ICON
   ========================================================= */

.qh-employer .htp-icon {
  width: 56px;
  height: 56px;

  flex-shrink: 0;

  border-radius: 14px;

  background: var(--htp-accent-tint);

  display: flex;

  align-items: center;
  justify-content: center;

  margin-bottom: 0;
}

.qh-employer .htp-icon svg {
  width: 28px;
  height: 28px;

  stroke: var(--htp-accent-deep);
}


/* =========================================================
   CONTENT
   ========================================================= */

.qh-employer .htp-spotlight-text {
  flex: 1;

  min-width: 260px;
}

.qh-employer .htp-tag {
  display: inline-block;

  width: fit-content;

  padding: 4px 9px;

  margin-bottom: 12px;

  border-radius: 16px;

  background: var(--htp-accent-tint);

  color: var(--htp-accent-deep);

  font-family: "JetBrains Mono", monospace;

  font-size: 10.5px;

  text-transform: uppercase;

  letter-spacing: 0.03em;
}

.qh-employer .htp-spotlight-text h3 {
  font-family: "Poppins", sans-serif;

  font-size: 19px;

  line-height: 1.3;

  margin: 0 0 6px;
}

.qh-employer .htp-spotlight-text p {
  font-size: 14px;

  color: var(--qh-steel);

  margin: 0 0 10px;
}


/* =========================================================
   STAT / META
   ========================================================= */

.qh-employer .htp-meta {
  font-family: "JetBrains Mono", monospace;

  font-size: 11px;

  color: var(--htp-accent-deep);

  padding-top: 14px;

  margin-top: 14px;

  border-top: 1px dashed var(--qh-line);
}


/* =========================================================
   RIGHT SIDE LINK
   ========================================================= */

.qh-employer .htp-link {
  font-size: 14px;

  font-weight: 600;

  color: var(--htp-accent-deep);

  white-space: nowrap;

  text-decoration: none;
}

.qh-employer .htp-spotlight:hover .htp-link {
  color: var(--htp-accent);
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 700px) {
  .qh-employer .hiring-tracks-preview {
    padding: 60px 0;
  }

  .qh-employer .hiring-tracks-preview .wrap {
    padding: 0 24px;
  }

  .qh-employer .hiring-tracks-preview .section-head {
    margin-bottom: 40px;
  }

  .qh-employer .htp-spotlight-wrap {
    padding: 0 24px;
  }

  .qh-employer .htp-spotlight {
    padding: 30px 26px;
  }

  .qh-employer .htp-spotlight-inner {
    flex-direction: column;

    align-items: flex-start;

    gap: 20px;
  }

  .qh-employer .htp-spotlight-text {
    min-width: 0;
    width: 100%;
  }

  .qh-employer .htp-link {
    white-space: normal;
  }
}

/* =========================================================
   CTA BAND
   ========================================================= */

.qh-cta-band {
  position: relative;

  overflow: hidden;

  background: #14150f;

  color: #f5f6f2;

  padding: 90px 32px;
}


.qh-cta-band-inner {
  max-width: 1180px;

  margin: 0 auto;

  display: grid;

  grid-template-columns: 0.85fr 1.15fr;

  gap: 64px;

  align-items: start;
}


.qh-cta-copy h2 {
  margin: 0 0 16px;

  font-size: clamp(26px, 3.2vw, 38px);

  line-height: 1.16;

  letter-spacing: -0.025em;

  font-weight: 600;

  color: #f5f6f2;
}


.qh-cta-copy p {
  max-width: 420px;

  margin: 0;

  font-size: 15.5px;

  line-height: 1.65;

  color: rgba(245, 246, 242, 0.65);
}


.qh-cta-copy .qh-tag {
  color: #1caa3c;
}


.qh-cta-points {
  display: flex;

  flex-direction: column;

  gap: 14px;

  margin: 32px 0 0;

  padding: 0;

  list-style: none;
}


.qh-cta-points li {
  display: flex;

  align-items: flex-start;

  gap: 10px;

  font-size: 14px;

  line-height: 1.5;

  color: rgba(245, 246, 242, 0.78);
}


.qh-cta-points li::before {
  content: "✓";

  flex-shrink: 0;

  color: #1caa3c;

  font-weight: 600;
}


/* =========================================================
   EMPLOYER FORM
   ========================================================= */

.qh-cta-form-card {
  background: rgba(245, 246, 242, 0.04);

  border: 1px solid rgba(245, 246, 242, 0.14);

  border-radius: 6px;

  padding: 32px;
}


.qh-employer-form {
  display: flex;

  flex-direction: column;

  gap: 18px;
}


.qh-form-row {
  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 16px;
}


.qh-form-field {
  display: flex;

  flex-direction: column;

  gap: 7px;
}


.qh-form-field label {
  font-family: "JetBrains Mono", monospace;

  font-size: 10.5px;

  line-height: 1.4;

  letter-spacing: 0.04em;

  text-transform: uppercase;

  color: rgba(245, 246, 242, 0.65);
}


.qh-form-field input,
.qh-form-field select,
.qh-form-field textarea {
  width: 100%;

  box-sizing: border-box;

  border: 1px solid rgba(245, 246, 242, 0.16);

  border-radius: 3px;

  background: rgba(245, 246, 242, 0.06);

  color: #f5f6f2;

  padding: 12px 13px;

  font-family: inherit;

  font-size: 14px;

  line-height: 1.4;

  outline: none;

  transition:
    border-color 0.15s ease,
    background 0.15s ease;
}


.qh-form-field input::placeholder,
.qh-form-field textarea::placeholder {
  color: rgba(245, 246, 242, 0.38);
}


.qh-form-field select {
  color: rgba(245, 246, 242, 0.7);
}


.qh-form-field select option {
  background: #14150f;

  color: #f5f6f2;
}


.qh-form-field textarea {
  min-height: 110px;

  resize: vertical;
}


.qh-form-field input:focus,
.qh-form-field select:focus,
.qh-form-field textarea:focus {
  border-color: #1caa3c;

  background: rgba(245, 246, 242, 0.08);
}


/* Submit */

.qh-form-submit {
  width: 100%;

  border: none;

  border-radius: 2px;

  background: #1caa3c;

  color: #ffffff;

  padding: 14px 20px;

  font-size: 14px;

  font-weight: 600;

  cursor: pointer;

  transition:
    background 0.15s ease,
    transform 0.15s ease;
}


.qh-form-submit:hover {
  background: #176d2e;

  transform: translateY(-1px);
}


.qh-form-note {
  margin: 0;

  text-align: center;

  font-family: "JetBrains Mono", monospace;

  font-size: 10.5px;

  line-height: 1.5;

  color: rgba(245, 246, 242, 0.45);
}


/* Reference-parity corrections for shared tokens and inner widths. */
.qh-employer-hero,
.qh-not-ats,
.qh-audience {
  background: var(--qh-paper);
}

.qh-layers {
  background: var(--qh-paper-dim);
}

.qh-employer-hero,
.qh-stat-strip,
.qh-compare,
.qh-layer-list,
.qh-layer,
.qh-compare-col li {
  border-color: var(--qh-line);
}

.qh-hero-eyebrow,
.qh-tag,
.qh-layer-index,
.qh-mono,
.qh-hero-inner h1 em,
.qh-stat-number span {
  color: var(--qh-quantum-deep);
}

.qh-hero-eyebrow {
  border-color: var(--qh-line);
}

.qh-hero-lede,
.qh-section-head p,
.qh-layer p,
.qh-aud-card p,
.qh-stat-label,
.qh-compare-col .mk {
  color: var(--qh-steel);
}

.qh-compare-col.old {
  background: var(--qh-paper-dim);
}

.qh-stat + .qh-stat,
.qh-compare-col + .qh-compare-col {
  border-color: var(--qh-line);
}

.qh-compare-col.new {
  background: var(--qh-ink);
}

.qh-compare-col.new li {
  border-color: var(--qh-line-dark);
}

.qh-aud-grid {
  background: var(--qh-line);
}

.qh-hero-ghost {
  border-color: var(--qh-line);
}

.qh-hero-ghost:hover {
  border-color: var(--qh-quantum-deep);
  color: var(--qh-quantum-deep);
}

.qh-not-ats > .qh-wrap,
.qh-layers > .qh-wrap,
.qh-audience > .qh-wrap {
  padding-inline: 32px;
}

.qh-cta-band {
  scroll-margin-top: 76px;
}

.qh-employer-form {
  gap: 16px;
}

.qh-form-row {
  gap: 14px;
}

.qh-form-field {
  gap: 6px;
}

.qh-form-field label {
  color: rgba(245, 246, 242, 0.55);
  font-size: 11px;
  letter-spacing: 0.03em;
}

.qh-form-field input,
.qh-form-field select,
.qh-form-field textarea {
  border-color: rgba(245, 246, 242, 0.18);
  padding: 11px 13px;
  font-family: "Inter", sans-serif;
  font-size: 14.5px;
}

.qh-form-field textarea {
  min-height: 84px;
}

.qh-form-submit {
  margin-top: 6px;
  border-radius: 3px;
  color: var(--qh-ink);
  font-size: 14.5px;
}

.qh-form-submit:hover {
  color: var(--qh-paper);
}

.qh-form-note {
  margin-top: 2px;
  color: rgba(245, 246, 242, 0.4);
  font-size: 11px;
  text-align: left;
}

/* Final computed values from the supplied reference. */
.qh-employer :focus-visible {
  outline: 2px solid var(--qh-quantum);
  outline-offset: 3px;
}

.qh-hero-eyebrow {
  font-size: 11.5px;
  line-height: normal;
  letter-spacing: 0.02em;
}

.qh-hero-dot {
  width: 6px;
  height: 6px;
}

.qh-hero-inner h1,
.qh-section-head h2,
.qh-cta-copy h2 {
  letter-spacing: -0.02em;
}

.qh-hero-lede {
  color: var(--qh-ink-soft);
}

.qh-hero-primary,
.qh-hero-ghost,
.qh-stat-number,
.qh-stat-label,
.qh-tag,
.qh-compare-label,
.qh-compare-col li,
.qh-layer-index,
.qh-layer h3,
.qh-mono,
.qh-aud-card h3,
.qh-form-field label,
.qh-form-field input,
.qh-form-field select,
.qh-form-field textarea,
.qh-form-note {
  line-height: normal;
}

.qh-stat-number {
  letter-spacing: normal;
}

.qh-compare-col .mk {
  width: auto;
}

.qh-hero-primary:hover,
.qh-form-submit:hover {
  background: var(--qh-quantum-deep);
}

.qh-form-field select {
  color: var(--qh-paper);
}

.qh-form-field input::placeholder,
.qh-form-field textarea::placeholder {
  color: rgba(245, 246, 242, 0.35);
}

.qh-form-field input:focus,
.qh-form-field select:focus,
.qh-form-field textarea:focus {
  background: rgba(245, 246, 242, 0.06);
}

.qh-form-submit:hover {
  transform: none;
}

@media (max-width: 860px) {
  .qh-stat-strip {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 24px;
  }

  .qh-stat:nth-child(2n) {
    border-left: none;
  }

  .qh-stat:nth-child(n + 3) {
    border-top: 1px solid var(--qh-line-dark);
    padding-top: 20px;
  }

  .qh-compare {
    grid-template-columns: 1fr;
  }

  .qh-compare-col + .qh-compare-col {
    border-top: 1px solid var(--qh-line);
    border-left: none;
  }

  .qh-layer {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .qh-aud-grid,
  .qh-cta-band-inner {
    grid-template-columns: 1fr;
  }

  .qh-cta-band-inner {
    gap: 44px;
  }

  .qh-cta-form-card {
    padding: 26px;
  }
}

@media (max-width: 640px) {
  .qh-form-row {
    grid-template-columns: 1fr;
  }
}

`}</style>
);
